import React, { useState } from "react";
import { ActivityIndicator, Alert, Button, Image, Text, View, ScrollView } from "react-native";
import MCALayout from "../../components/MCALayout";
import { colorGreyOverlay, colorPrimary } from "../../theme/colors";
import  MCATextField  from "../../components/MCATextField";
import MDatePicker  from "../../components/MDatePicker";
import FilePicker from "../../components/FilePicker";
import ItemPair from "../../components/ItemPair";
import SuccessScreen from "../../components/SuccessScreen";
import { useApiKeyStore } from "../../store/urlApiKeyStore";

interface ProductData {
  name: string;
  form_fields: any[]; // Update this type according to the actual structure
  prefix: string;
  [key: string]: any;
}

interface FormData {
  [key: string]: any;
}

interface FileDetail {
  uri: string;
  name: string;
  [key: string]: any;

}

// interface FilePickerData {
//   input_type: string;
//   label: string;
//   [key: string]: any;
// }

interface Props {
  navigation: any; // Update with proper navigation type
  route: any; // Update with proper route type
}

const ProductFormsScreen = ({ navigation, route }: Props) => {

const { apiKey, baseUrl } = useApiKeyStore();
    const productData: ProductData = route.params.data;
    const transactionRef: string = route.params.transactionRef || "";


    const [formData, setFormData] = useState<FormData>({});
    const [fieldIndex, setFieldIndex] = useState(0);
    const [files, setFiles] = useState<FileDetail[]>([]);
    const [complete, setComplete] = useState(false);
    const [busy, setBusy] = useState(false);

    const formFields = productData.form_fields.filter(item =>
        transactionRef.trim().length < 1 ? item.show_first : !item.show_first
    ).sort((a, b) => a.position - b.position);

    function updateData(key: string, value: any) {
        setFormData(prevData => ({
            ...prevData,
            [key]: value
        }));
    }

    function progressOrNavigate() {
        if (fieldIndex < chunkedFields().length - 1) {
          console.log(`Form Data`);
          console.log(formData);
          setFieldIndex(fieldIndex + 1);
        } else {
            if (!transactionRef) {
              console.log(`Form Data`);
              console.log(formData);
              setFieldIndex(0);
              navigation.navigate("PaymentOptionScreen", { data: { product: productData, form: formData } });

            } else {
                completePurchase();
            }
        }
    }

    function chunkedFields() {
        const chunkSize = 3;
        const chunkedFields: any[] = [];
        for (let i = 0; i < formFields.length; i += chunkSize) {
            const chunk = formFields.slice(i, i + chunkSize);
            chunkedFields.push(chunk);
        }
        return chunkedFields;
    }

    function resolveFields() {
        return chunkedFields()[fieldIndex];
    }

    async function uploadFiles() {
        console.log('file upload');
        for (let i = 0; i < files.length; i++) {
          console.log(files);
          console.log(files.length);
            const formData = new FormData();
            formData.append("file", { uri: files[i]?.uri, type: "image/png", name: files[i]?.name });
            const headers = {
                Authorization: "Bearer " + apiKey,
                Accept: "application/json",
                "Content-Type": "multipart/form-data"
            };
            const url = baseUrl + "/v1/upload-file";
            try {
                const response = await fetch(url, {
                    method: "POST",
                    headers: headers,
                    body: formData
                });
                const json = await response.json();
                if (json.responseCode == 1) {
                    updateData(files[i]?.key, json.data.file_url);
                }
            } catch (error) {
                console.log(error);
            }
        }
    }

    function completePurchase() {
        setBusy(true);
        uploadFiles().then(() => {
            updateData("is_full_year", true);
            const url = baseUrl + "/v1/sdk/complete-purchase";
            const headers = { Authorization: "Bearer " + apiKey, "Content-Type": "application/json" };
            const body = JSON.stringify({
                payload: formData,
                reference: transactionRef
            });
          
            fetch(url, { method: "POST", headers: headers, body })
                .then((response) => response.json())
                .then((json) => {
                    console.log("json");
                    console.log(json);
                    if (json.responseCode == 1) {
                        console.log(complete);
                        setComplete(true);
                    } else {
                        Alert.alert("Request Failed", json.responseText);
                    }
                })
                .finally(() => setBusy(false));
        });
    }

    function onFilePicked(key: string, file: FileDetail) {
      console.log('select file');  
      console.log(file);      
        setFiles([...files, { key: key, ...file }]);
    }

    function onBackPressed() {
        if (fieldIndex > 0) {
            setFieldIndex(fieldIndex - 1);
        }
    }
    function onDone() {
      navigation.navigate("ProductList");
  }

  if (complete) {
    console.log("Product Data:", productData);
    console.log("Product Name:", productData.name);
      return <SuccessScreen message={"Your purchase for " + productData.name + " was successful."} onDonePressed={onDone} />;
  } else {
    return (
      <ScrollView>
        <View style={{flex: 1}}>
          
            <MCALayout onBackPressed={onBackPressed}>
                <View style={{ alignItems: "center" }}>
                    <Text style={{ fontSize: 16, fontWeight: "600", padding: 12, fontFamily: "Raleway_500Medium" }}>{productData.name}</Text>
                    <Text style={{ padding: 5, width: "100%", fontFamily: "Raleway_400Regular", backgroundColor: "#F6FEF9" }}>Enter Details as it appears on legal document</Text>
                    <View style={{ flexDirection: "row", marginVertical: 12, alignItems: "center" }}>
                        <View style={{ flex: 1 }}></View>
                        <Text style={{ fontFamily: "Raleway_400Regular" }}>Underwritten By: </Text>
                        {getImage(productData.prefix)}
                    </View>
                </View>
              
                <View style={{ flex: 1 }}>
                    {resolveFields().map((element: any, index: number) => {
                        const dataType = element.data_type.toLowerCase();
                        function onDataChange(value: any) {
                            console.log("ON data change")
                            console.log(value)
                            console.log(element.name)
                            if (dataType == "array") {
                                updateData(element.name, value);
                            } else if (dataType == "number") {
                                updateData(element.name, parseInt(value));
                            } else if (dataType == "boolean") {
                                updateData(element.name, value.toLowerCase() == "true" ? true : false);
                            } else {
                              console.log('string');
                              console.log(formData);
                                updateData(element.name, value);
                            }
                        }
                        if (dataType == "array") {
                            return <ItemPair key={index} onUpdate={onDataChange} data={element} />;
                        }
                        console.log(`Name: ${element.name}`);
                        console.log(`Label: ${element.label}`);
                        
                        
                        switch (element.input_type) {
                            case "file":
                                return <FilePicker key={index} onFilePicked={onFilePicked} data={element} />;
                            case "date":
                                return <MDatePicker key={index} dateValueChanged={onDataChange} keyValue={element.label} editable={false} data={element} />;
                            default:
                                return (
                                    <MCATextField
                                        onDataChange={onDataChange}
                                        valueString={formData[element.name]}
                                        keyValue={element.label}
                                        editable={true}
                                        data={element}
                                        key={index}
                                    />
                                );
                        }
                    })}
                </View>
                

                <Button onPress={progressOrNavigate} color={colorPrimary} title="Continue" />
            </MCALayout>
            {busy ? (
                <View style={{ zIndex: 2, flex: 1, height: "100%", width: "100%", marginTop: "6%", position: "absolute", justifyContent: "center", alignItems: "center", backgroundColor: colorGreyOverlay, marginBottom:5 }}>
                    <ActivityIndicator style={{ margin: 12, borderColor: "#3BAA90" }} animating={true} />
                    <Text style={{ fontFamily: "Raleway_500Medium", margin: 12, fontSize: 16, color: "white" }}>Sending request...</Text>
                </View>
            ) : null}
           
        </View>
        </ScrollView>
    );
}

}


export default ProductFormsScreen


export function getImage(name: string, showText: boolean = true): JSX.Element | null {
  const newName = name.toLowerCase();
  const style = { marginHorizontal: 5 };
  if (newName.includes("mcg") || newName.includes("mycovergenius")) {
      return <Image style={style} source={require("../../assets/mcg.png")} />;
  } else if (newName.includes("aiico")) {
      return <Image style={style} source={require("../../assets/aiico.png")} />;
  } else if (newName.includes("sti")) {
      return <Image style={style} source={require("../../assets/sti.png")} />;
  } else if (newName.includes("flexicare")) {
      return <Image style={style} source={require("../../assets/flexicare.png")} />;
  } else if (newName.includes("leadway")) {
      return <Image style={style} source={require("../../assets/leadway.png")} />;
  } else {
      if (showText === true) return <Text style={style}>{name.toUpperCase()}</Text>;
      else return null;
  }
}